import B_Define from '../../../base/dev/util/B_Define';
import B_Util from '../../../base/dev/util/B_Util';
import R_Canvas from './R_Canvas';
import B_Wrapper from '../../../base/dev/frame/B_Wrapper';
import R_Define from '../util/R_Define';

const init = () => {
    return class R_Wrapper extends B_Wrapper {
        constructor(id, queue, cb) {
            super(id, queue, cb, R_Canvas);
        }

        /**
         * [ Function :: setBG ]
         *
         * @DES :: 배경 설정 이벤트 월드에 전달
         * @IP1 :: bg {string}
         * @O.P :: null
         */
        setBG(bg) {
            this._objCanvas.WORLD.setBG(bg);
        }

        /**
         * [ Function :: gameOver ]
         *
         * @DES :: 게임 오버 이벤트 월드에 전달
         * @O.P :: null
         */
        gameOver() {
            this._objCanvas.WORLD.gameOver();
        }

        /**
         * [ Function :: addSolution ]
         *
         * @DES :: 솔루션 등록
         * @IP1 :: inputJson {object}
         * @O.P :: null
         */
        addSolution(inputJson) {
            const cloneJson = B_Util.clone(inputJson);

            if (cloneJson.answerSheet.block) { // 블록 솔루션
                cloneJson.type = R_Define.BLOCK_SOLUTION_TYPE;
            } else if (cloneJson.answerSheet.variable) { // 변수 솔루션
                cloneJson.type = R_Define.VARIABLE_SOLUTION_TYPE;
            } else if (cloneJson.answerSheet.inventory) { // 인벤토리 솔루션
                cloneJson.type = R_Define.INVENTORY_SOLUTION_TYPE;
            }

            this._protectedCanvas.world[cloneJson.id] = this._objCanvas.WORLD.addObject(cloneJson);
        }

        /**
         * [ Function :: reloadQuestion ]
         *
         * @DES :: 월드 초기화
         * @IP1 :: ...arg {array}
         * @O.P :: null
         */
        reloadQuestion(...arg) {
            this._objCanvas.WORLD.realod();

            super.reloadQuestion(...arg);
        }

        /**
         * [ Function :: run ]
         *
         * @DES :: 게임 시작
         * @O.P :: null
         */
        run() {
            this._objCanvas.WORLD.INTERPRETER.init();
        }

        /**
         * [ Function :: setVariable ]
         *
         * @DES :: 변수 등록
         * @IP1 :: inputJson {object}
         * @O.P :: null
         */
        setVariable(inputJson) {
            const cloneJson = B_Util.clone(inputJson);

            cloneJson.type = B_Define.VARIABLE_REAL_TYPE;

            if (
                this._objCanvas.WORLD[cloneJson.id]
                && typeof this._objCanvas.WORLD[cloneJson.id].remove === 'function'
            ) this._objCanvas.WORLD[cloneJson.id].remove();

            this._protectedCanvas.world[cloneJson.id] = this._objCanvas.WORLD.addObject(cloneJson);
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/frame/R_Wrapper.js